import React, { Fragment } from "react";
import "../Task/Task.css";

import { Container } from "reactstrap";

import heroImg from "../../assests/images/hero-img1.png";
import TaskCard from "../Task/TaskCard";
import Header from "../Header/Header";
import Navmenu from "../Navmenu/Navmenu";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../Footer/Footer";


const taskdata = [
    {
        task_id: "21",
        content_title: `Вольфрам сымының кедергісі   .
        Басқаша жағынан, Ом заңы бойынша    .
        Температуралар айырмасы     .    
        Есептеу программасын құрастырайық:
        `,
        id_faq: "faq_21",
        for_faq: "faq_21",
        question: `Электр шамының вольфрамнан жасалған сымының (жібінің) температурасы t1 =200C болған кезде,оның кедергісі R1=35.8 Ом –ға тең болады. Егер U= 220 B тоқ көзіне қосқан кезде, сымның бойымен I =0.5 А тоқ жүріп өтсе, онда электр шамы сымының    T2  температурасы қандай мәнге ие болады? Вольфрамның температуралық кедергі коэффициенті t1 =200C-да  
        α=0.0051 K-1 -ге тең.
        `,
        img_url: heroImg,
        answers: `#Вольфрам жібі
        alp=5.1e-3; T0=273; t1=20; R1=35.8; U=220; I=0.5;
        R2=U/I; Dt=(R2/R1-1)/alp; t2=t1+Dt; T2=t2+T0;
        print('T2=',T2)
        `,
        languages: "python",
        container_id: 21,
        img1: `Снимок экрана (1096).png`,
        img2: ``,
    },
    {
        task_id: "22",
        content_title: `⦁	Элементтерді параллель жалғау
        ⦁	 Элементерді тізбектеп жалғау
        
        
        Есептеу программасын құрастырайық:
        Қоректендіру элементтерін параллель жалғағанда және ең кіші сыртқы кедергіні қосқанда     мәніне тең ең үлкен  тоқ күші шамасына жетуге болады.
        `,
        id_faq: "faq_22",
        for_faq: "faq_22",
        question: `Электр қозғаушы күштері (ЭҚК)     және  ішкі кедергілері  
        бірдей екі гальваникалық элемент берілген. Егер кедергілер жүктемелері  а)   болса, сыртқы тізбекте ең үлкен тоқ күшін алу үшін бұл гальваникалық элементтерді (тізбектеп немесе параллель) қалай жалғау керек? Әрбір жағдайдағы тоқ күшін анықтаңыздар.
       `,
        img_url: heroImg,
        answers: `#Екі ток көзі
        E1=1.5; E2=1.5; R1=0.2; R2=16.; r1=0.3; r2=0.3;
        r3=r1*r2/(r1+r2); E3=E1;
        I1=E3/(R1+r3);I2=E3/(R2+r3);
        r4=r1+r2; E4=E1+E2;
        I3=E4/(R1+r4);I4=E4/(R2+r4);
        print('I1=',I1,'\nI2=',I2,'\nI3=',I3,'\nI4=',I4)
        `,
        languages: "python",
        container_id: 22,
        img1: `Снимок экрана (1097).png`,
        img2: ``,
    },
    {
        task_id: "23",
        content_title: `Есептің шартында амперметрдің RA  кедергісі және батарея элементінің r ішкі кедергісі келтірілмеген, сондықтан оларды нольге тең деп есептейміз: RA  = 0, r = 0.
        Сызба-нұсқаның эквивалентті кедергісі 
        Амперметрдің көрсеткіші Ом заңынан анықталады:     .
        Вольтметрдің көрсеткішін келесі қатынастан табамыз:
        `,
        id_faq: "faq_23",
        for_faq: "faq_23",
        question: `14-суретте көрсетілген сызба-нұсқадағы амперметр және вольтметрдің көрсетулерін анықтаңыздар. Батарея элементінің  электр қозғаушы күші (ЭҚК) ε = 110 В, R1 = 400 Ом, R2 = 600 Ом, вольтметрдің кедергісі Rv=1000 Ом.`,
        img_url: heroImg,
        answers: `# Амперметр және вольтметр
        E=110; R1=400; R2=600; RV=1000;
        R3=R2*RV/(R2+RV);
        IA=E/(R1+R3);
        UV=E-IA*R3;
        print('IA=',IA,'\nUV=',UV)
        `,
        languages: "python",
        container_id: 23,
        img1: `Снимок экрана (1098).png`,
        img2: ``,
    },
    {
        task_id: "24",
        content_title: `Электр шамдары қалыпты жағдайда жұмыс жасау үшін олардың әрқайсысынан  Il  тоқ жүру керек, сондықтан қосымша rd  кедергі арқылы тоқ күшінің қосындысына тең  i = 4 il  тоқ жүріп өтеді. Электр шамдарының кедергісі   . Ом заңы бойынша толық тізбек үшін   . Мұнда    Сонымен Қосымша кедергі    `,
        id_faq: "faq_24",
        for_faq: "faq_24",
        question: `Әрқайсысы U1=3 B кернеуге және Il =0.3 A тоқ күшіне есептелген төрт электр шамы бір-бірімен параллель жалғанған және электр қозғаушы күші (ЭҚК) ε = 5.4 B тұрақты тоқ көзінен нәр алады. Шамдар тізбегіне қандай қосымша Rd   кедергіні тізбектеп жалғауға болады? Тоқ көзінің ішкі кедергісін ескермеуге болады. `,
        img_url: heroImg,
        answers: `# Шамдар батареясы
        E=5.4; U1=3; I1=0.3;
        R1=U1/I1; R3=R1/4; I=4*I1; Rd=E/I-R3;
        print('Rd=',Rd)
        `,
        languages: "python",
        container_id: 24,
        img1: `Снимок экрана (1100).png`,
        img2: ``,
    },
    {
        task_id: "25",
        content_title: `Электр тізбегіндегі қысқа тұйықталу сыртқы кедергі нольге тең болған кезде орындалады, олай болса қысқа тұйықталу кезіндегі тоқ күшін келесі өрнектен анықтаймыз:   , r – тоқ көзінің ішкі кедергісі.
        ε және r екі белгісіздер үшін екі алгебралық теңдеулерін жүйесін құрамыз:
        
        
        
        Теңдеулер жүйесінен тоқ көзінің ішкі кедергісін анықтаймыз:
        
        
        
        Жүйедегі бірінші теңдеуден  электр қозғаушы  күшті  ε –ді табамыз. Қысқа тұйықталу кездегі  тоқ күшін  ε/r қатынасы арқылы анықтаймыз.
        `,
        id_faq: "faq_25",
        for_faq: "faq_25",
        question: `Сыртқы кедергі    болған кезде тізбектегі тоқ күші    –ге тең, ал сыртқы кедергі    болған кезде тізбектегі тоқ күші    –ге тең. Қысқа тұйықталу I* тоқ күшін анықтаңыздар.`,
        img_url: heroImg,
        answers: `
        # Ом заңы 1
        R1=8; R2=15; I1=0.8; I2=0.5;
        r=(I2*R2-I1*R1)/(I1-I2); E=I1*(R1+r); IZ=E/r;
        print('r =',r,'\nE =',E,'\nIZ=',IZ)
        `,
        languages: "python",
        container_id: 25,
        img1: `Снимок экрана (1099).png`,
        img2: ``,
    },
    {
        task_id: "26",
        content_title: `А,В,С – шамдары
 
        электр кедергілерімен сипатталынады, ал шамдар арқылы қалыпты қызу барысын
        
          мына тоқтар қамтамасыз етеді. 
        Алдымен 16-суреттегі (a) сызба-нұсқасын қарастырамыз және А, В шамдары арқылы өтетін тоқ күшін есептейміз: 
        
        
        Ал С шамы арқылы өтетін тоқ күші    
        
        16-суреттегі (б) сызба-нұсқасын қарастырамыз және С шамы арқылы өтетін тоқ күшін есептейміз:  , мұнда толық кедергі 
        
        
        
        А және В шамдары арқылы өтетін тоқ күші бірдей,   
        `,
        id_faq: "faq_26",
        for_faq: "faq_26",
        question: `Қуаттары  болатын 110 вольттық үш электр қыздырғыш шамдары берілген. Осы шамдар  –қа тең желі кернеуінде қалыпты қыздыру беруі үшін, оларды қалай қосу керек. Қалыпты қыздыру кезіндегі  электр шамдары арқылы ағып өтетін  тоқ   күштерін анықтаңыз.`,
        img_url: heroImg,
        answers: `# Ом заңы 2
        PA=40; PB=40; PC=80; UA=110; UB=110; UC=110; U0=220;
        RA=UA*UA/PA; RB=UB*UB/PB; RC=UC*UC/PC;
        IA=PA/UA; IB=PB/UB; IC=PC/UC;
        IA1= U0/(RA+RB); IC1= U0/RC;
        R3=RC+RA*RB/(RA+RB);
        IC2= U0/R3; IA2= RB*IC2/(RA+RB); IB2=IC2-IA2;
        print('IA =',IA,'\nIC =',IC)
        print('1) IA =',IA1,'\n IC =',IC1)
        print('2) IA =',IA2,'\n IC =',IC2)
        `,
        languages: "python",
        container_id: 26,
        img1: `Снимок экрана (1102).png`,
        img2: ``,
    },
    {
        task_id: "27",
        content_title: `Эквивалентті R0 кедергісін есептеу үшін Кирхгоф ережесін қолданамыз. 17,б – суретте көрсетілгендей етіп схемаға кернеу көзін жалғаймыз және резистордың кедергісі R =1 Ом болсын. Ом заңынан    . 17-суретте тоқ күштерінің    I1 , I2 , I3 , I4 , I5 , I   бағыттарын  көрсетіп, сонан соң Кирхгоф ережесі бойынша алгебралық теңдеулер жүйесін құрастырамыз: Numpy математикалық кітапханасынан  solve процедурасын қолданып,
        I=M-1*B матрицалық теңдеудің  шешімін анықтаймыз.
        I1 , I2 , I3 , I4 , I5 , I   тоқ күштерін есептейтін программа құрастырайық:
        `,
        id_faq: "faq_27",
        for_faq: "faq_27",
        question: `17-суретте көрсетілген электр схемасының бөлігіндегі R0 кедергісін анықтаңыз. `,
        img_url: heroImg,
        answers: `# Кирхгоф ережелері 0A
        import numpy as np
        E=1.5;R=1.0;
        R1=3*R;R2=4*R;R3=3*R;R4=4*R;R5=2*R;
        M = np.array([[-1.,0.,0.,-1.,0.,1.],
                      [1.,-1.,-1.,0.,0.,0.],
                      [0.,0.,1.,1.,-1.,0.],
                      [R1,R2,0.,0.,0.,0.],
                      [R1,0.,R3,-R4,0.,0.],
                      [0.,R2,-R3,0.,-R5,0.]])
        B=np.array([0.,0.,0.,E,0.,0.])
        I=np.linalg.solve(M, B);
        R0=E/I[5];
        print ('R0=',R0)
        print ('I1=',I[0],'I2=',I[1],'I3=',I[2])
        print ('I4=',I[3],'I5=',I[4],'I =',I[5])
        print (I[5]-I[0]-I[3], I[0]-I[1]-I[2],I[2]+I[3]-I[4])
        `,
        languages: "python",
        container_id: 27,
        img1: `Снимок экрана (1104).png`,
        img2: ``,
    },
    {
        task_id: "28",
        content_title: `R1  және  R2 сыртқы кедергілерде  таралатын P1  және P2 пайдалы жылу қуаттары келесі өрнекпен анықталады:     




        Теңдеулер жүйесін құрастырайық:
                    
        Оң жақтағы теңдеулер жүйесін M*X =B  түрінде елестетелік:
        
        Бұның шешімі X=M-1 *B түрінде анықталады:
        
        `,
        id_faq: "faq_28",
        for_faq: "faq_28",
        question: `Элементтер батареясын алдымен R1 = 2 Ом сыртқы кедергімен, сосын R2 = 0,5 Ом сыртқы кдергімен тұйықтайды. Егер әрбір жағдайдағы сыртқы тізбекте бөлініп шығатын қуат шамалары жағынан бірдей және P1 =P2=2.54 Вт болатын болса, онда гальваникалық элементтер батареясының ішкі r кедергісін және  ε - электр қозғаушы күшін (ЭҚК) анықтаңыз.`,
        img_url: heroImg,
        answers: `# Джоуль-Ленц заңы
        import numpy as np
        R1=2; R2=0.5; P1=2.54; P2=2.54;
        I1=np.sqrt(P1/R1); I2=np.sqrt(P2/R2);
        M = np.array([[I1, -I1*I1], [I2, -I2*I2]]);
        B = np.array([P1, P2]);
        X=np.linalg.solve(M,B); [E,r]=X;
        print('E=',E,' r=',r)
        Y=np.dot(M,X)-B;
        print('Y=',Y)
        `,
        languages: "python",
        container_id: 28,
        img1: `Снимок экрана (1106).png`,
        img2: ``,
    },
    {
        task_id: "29",
        content_title: `Қысқа тұйықталу тоқ күші        
        Олай болса, батареяның ішкі кедергісі     
        Пайдалы жылу қуаты       
        Батареяның максимал пайдалы қуатын анықтау үшін, қуаттан тоқ күші бойынша туынды алып, оны нольге теңестіреміз.
        =0  немесе  
        Соңғы бөлшектегі  2r =R+r , сондықтан бұл жағдайда сыртқы кедергі R=r болады.
        Батареяның максимал пайдалы қуаты   
        Қуаттың кедергіге байланысты графигін тұрғызамыз. 
        Есептеу программасын құрастырайық:
        (`,
        id_faq: "faq_29",
        for_faq: "faq_29",
        question: `Аккумуляторлар батареясының электр қозғаушы күші (ЭҚК) ε = 12B, қысқа тұйықталу тоқ күші I* = 5 А. Осындай батареяға жалғанған сыртқы тізбекте қандай максимал Pmax  қуатты алуға болады? `,
        img_url: heroImg,
        answers: `# Қысқа тұйықталу
        import matplotlib.pyplot as plt
        E=12; IZ=5;
        r=E/IZ; Imax=E/2/r; Pmax=E*Imax-Imax*Imax*r
        print(r,Imax,E*Imax,Imax*Imax*r)
        Rmin=0.0; Rmax=5.0*r; NR=500; dR=(Rmax-Rmin)/NR;
        R=[]; P=[];
        R.append(Rmin); P.append(0);
        for i in range(1,NR):
            RR=Rmin+i*dR;
            PP=E*E*(1-r/(r+RR))/(r+RR);
            R.append(RR); P.append(PP);
        plt.plot(R,P,'k-')
        plt.plot([r,r], [0,16], 'k--')
        plt.grid(True)
        plt.xlabel('$R,\; Ом$',fontsize=16)
        plt.ylabel('$P,\; Вт$',fontsize=16)
        plt.show()
        `,
        languages: "python",
        container_id: 29,
        img1: `29-мысал.gif`,
        img2: `Снимок экрана (1108).png`,
    },
    {
        task_id: "30",
        content_title: `Белгісіз тоқ күштерінің саны үшеу, сондықтан Кирхгоф ережесі бойынша үш теңдеу құрастыру қажет:

        Бұл теңдеулер жүйесінің  M*X = B  матрицалық түрі төменде келтірілген:        `,
        id_faq: "faq_30",
        for_faq: "faq_30",
        question: `
        19-суреттегі сызба-нұсқада келтірілген параметрлердің мәндері келесідей: 
        Ішкі кедергі өте аз.  ,  және   тоқ күштерін анықтаңыздар.`,
        img_url: heroImg,
        answers: `# Кирхгоф ережелері 1
        import numpy as np
        E1=10; E2=20; E3=30;
        R1=1; R2=2; R3=3; R4=4; R5=5; R6=6; R7=1;
        M=np.array([[1,1,-1],[R1+R2+R6,0,R7],[0,R3+R4+R5,R7]]);
        B=np.array([0,E1-E2,-E2-E3]);
        X=np.linalg.solve(M,B); [I1,I2,I3]=X;
        print('I1=',I1,'\nI2=',I2,'\nI3=',I3)
        IS=I1+I2-I3
        print('IS=',IS)
        `,
        languages: "python",
        container_id: 30,
        img1: `Снимок экрана (1109).png`,
        img2: ``,
    },
    {
        task_id: "31",
        content_title: `Сызба-нүсқадағы тілшесі бар дөңгелек генераторды көрсетеді, ал тілше тоқ күшінің бағытын береді. Аккумулятор зарядтау режімінде болған кезде, аккумулятор арқылы жүріп өтетін тоқ күшінің бағыты оң полюстен (анод) теріс полюске (катод) қарай бағытталады. Біздің жағдайымызда бұл шарт келесі түрде жазылады: . Біздің сызба-нүсқамызда үш белгісіз   ,  және   тоқ күштері, екі түйін және екі бір-біріне байланыссыз контур бар. Кирхгоф ережесі бойынша бір-біріне байланыссыз үш сызықтық теңдеулер жүйесін құрамыз. 
        2-ші түйін үшін бірінші Кирхгоф ережесі:  .
        Төменгі контур үшін екінші Кирхгоф ережесі:   
        Жоғарғы контур үшін:    
        
        Бізді тек қана аккумулятор арқылы ағып өтетін тоқ күші ғана қызықтыратын болғандықтан, келесі ауыстыруды қарастыру жеткілікті   және осы ауыстыруды екінші және үшінші теңдеуге апарып қоямыз, ақырында екі сызықтық алгебралық теңдеуден тұратын жүйені аламыз
        
        `,
        id_faq: "faq_31",
        for_faq: "faq_31",
        question: `
        
Электр қозғаушы күші (ЭҚК)    және ішкі кедергісі    тұрақты тоқ генераторы , электр қозғаушы күші (ЭҚК)    және ішкі кедергісі    аккумуляторға сыртқы кедергі R арқылы жалғанған. R –дің қандай ең аз мәнінде аккумулятор зарядтау режімінде болады?
`,
        img_url: heroImg,
        answers: `# Аккумляторды зарядтау тогы
        import matplotlib.pyplot as plt
        E1=12; E2=1.5; r1=0.5; r2=0.25;
        Rmin=0.0; Rmax=0.50; NR=5000; dR=(Rmax-Rmin)/NR;
        R=[];
        I2=[];
        R.append(Rmin);
        I2.append(-E2/r2);
        print('I2(0)=',-E2/r2)
        print('I2(R>>r1,r2)=',(E1-E2)/(r1+r2))
        print('R(I2=0)',r1*E2/(E1-E2))
        for i in range(1,NR):
             RR=Rmin+i*dR;
             JJ=((E1-E2)*RR-r1*E2)/(r1*(r2+RR)+r2*RR);
             R.append(RR);
             I2.append(JJ);
        plt.plot(R,I2,'k-')
        plt.xlabel('$R$',fontsize=16)
        plt.ylabel('$I_2$',fontsize=16)
        plt.grid(True)
        plt.show()
        `,
        languages: "python",
        container_id: 31,
        img1: `31-мысал.gif`,
        img2: `Снимок экрана (1112).png`,
    },
    {
        task_id: "32",
        content_title: `Конденсатордың астарларының арасындағы потенциалдар айырымы   В және С түйіндерінің арасындағы потенциалдар     айырымына тең, оны біртекті емес BDC тізбек бөлігі үшін Ом заңынан анықтаймыз: 
        мұнда   . Олай болса, біз іздеп отырған потенциалдар айырымы   .
     Сонымен, Кирхгоф ережесі бойынша құрастырылған теңдеулер жүйесінен  тоқ күшін анықтауға алып келеді.
     Матрицалық теңдеулер шешімінен  тоқ күшінің шамасын біле отырып,  потенциалдар айырымын табамыз, ал конденсаторда жинақталған заряд шамасын   = C*∆φ  өрнегімен есептейміз. 
Есептеу программасын құрастырайық:
`,
        id_faq: "faq_32",
        for_faq: "faq_32",
        question: `
        Егер  
болса, онда конденсатор астарларының арасындағы потенциалдар айырымы   және q зарядтың шамасы қандай болады (22-сурет).
`,
        img_url: heroImg,
        answers: `# Тұрақты ток тізбегіндегі конденсатор
        import numpy as np
        E1=1.5; E2=1.5;
        R1=10; R2=20; R3=30;
        C=4.7e-6;
        M=np.array([[-1,1,1],[R1,R2,0],[0,-R2,R3]]);
        B=np.array([0,-E1,-E2]);
        X=np.linalg.solve(M,B); [I1,I2,I3]=X;
        print('I1=',I1,'\nI2=',I2,'\nI3=',I3)
        IS=I2+I3-I1;
        Dph=E2-R1*(E1*(R2+R3)+E2*R2)/(R1*R2+R1*R3+R2*R3);
        q=C*Dph;
        print('Dph=',Dph,'q=',q,'\nIS=',IS)
        `,
        languages: "python",
        container_id: 32,
        img1: `Снимок экрана (1113).png`,
        img2: ``,
    },
];

const structure = [
    {
        name: `ТҰРАҚТЫ ЭЛЕКТР ТОГЫ. ОМ ЗАҢДАРЫ`,
    },
];

const TaskCompElect = () => {
    return (
        <Fragment>
            <Header />
            {/* {structure.map((item) => (
                <Navmenu item={item} />
            ))} */}

            <br /><br /><br />

            <section>
                <Container className="taskmenu">
                    {taskdata.map((item) => (
                        <TaskCard item={item} />
                    ))}
                </Container>
            </section>
            <Sidebar />
            <Footer />
        </Fragment>
    );
};

export default TaskCompElect;
